export const GET_TRAINING_REQUEST = 'mtf/app/GET_TRAINING_REQUEST'
export const GET_TRAINING_SUCCESS = 'mtf/app/GET_TRAINING_SUCCESS'
export const GET_TRAINING_ERROR = 'mtf/app/GET_TRAINING_ERROR'

export const GET_TRAINING_BY_DATE_REQUEST = 'mtf/app/GET_TRAINING_BY_DATE_REQUEST'
export const GET_TRAINING_BY_DATE_SUCCESS = 'mtf/app/GET_TRAINING_BY_DATE_SUCCESS'
export const GET_TRAINING_BY_DATE_ERROR = 'mtf/app/GET_TRAINING_BY_DATE_ERROR'

export const GET_TRAINING_BY_ID_REQUEST = 'mtf/app/GET_TRAINING_BY_ID_REQUEST'
export const GET_TRAINING_BY_ID_SUCCESS = 'mtf/app/GET_TRAINING_BY_ID_SUCCESS'
export const GET_TRAINING_BY_ID_ERROR = 'mtf/app/GET_TRAINING_BY_ID_ERROR'

export const CREATE_TRAINING_ADMIN_REQUEST = 'mtf/app/CREATE_TRAINING_ADMIN_REQUEST'
export const CREATE_TRAINING_ADMIN_SUCCESS = 'mtf/app/CREATE_TRAINING_ADMIN_SUCCESS'
export const CREATE_TRAINING_ADMIN_ERROR = 'mtf/app/CREATE_TRAINING_ADMIN_ERROR'

export const GET_TRAINING_ADMIN_REQUEST = 'mtf/app/GET_TRAINING_ADMIN_REQUEST'
export const GET_TRAINING_ADMIN_SUCCESS = 'mtf/app/GET_TRAINING_ADMIN_SUCCESS'
export const GET_TRAINING_ADMIN_ERROR = 'mtf/app/GET_TRAINING_ADMIN_ERROR'